import { TaskNotificationStatus } from '@backoffice-frontend/graphql'

export const fleetControlAlertStatus = [
  TaskNotificationStatus.New,
  TaskNotificationStatus.InProgress,
  TaskNotificationStatus.Pending,
]
